import request from '@/utils/request'
const BASE_URL = '/orders'

export default {
  sync(data) {
    return request({
      url: BASE_URL + '/sync',
      method: 'post',
      data
    })
  },
  syncStatus() {
    return request({
      url: BASE_URL + '/syncstatus',
      method: 'get',
    })
  },
  getOrders(params) {
    return request({
      url: BASE_URL,
      method: 'get',
      params
    })
  },
}